// Demo discovery only. These entries do not configure or attest to a live integration.
// Carrier labels verified against https://www.intellimind.com/connectors on 2026-10-22.
// Mercury is the advertised label; no legal entity or API availability is inferred.
export const PLANNED_INSURANCE_CARRIERS = [
  { id: "aig", label: "AIG" },
  { id: "allianz_trade", label: "Allianz Trade" },
  { id: "atradius", label: "Atradius" },
  { id: "chubb", label: "Chubb" },
  { id: "coface", label: "Coface" },
  { id: "credendo", label: "Credendo" },
  { id: "groupama", label: "Groupama" },
  { id: "markel", label: "Markel" },
  { id: "mercury", label: "Mercury" },
  { id: "qbe", label: "QBE" },
];

export const GALLAGHER_INSURANCE_DEMO_TENANT_ID = "f9471bc0-c3b6-4f52-a0cd-ec6a328e54bb";
export const isInsuranceCarrierDemoEnabled = (tenantId) => tenantId === GALLAGHER_INSURANCE_DEMO_TENANT_ID;

export const plannedCarrierStorageKey = (tenantId) => `crediarc:insurance-planned-carriers:v1:${tenantId}`;

// Persist only known selection IDs. Browser storage can never establish connection status.
export function normalizePlannedCarrierSelection(value) {
  const ids = new Set(Array.isArray(value) ? value.filter((id) => typeof id === "string") : []);
  return PLANNED_INSURANCE_CARRIERS.filter((carrier) => ids.has(carrier.id)).map((carrier) => carrier.id);
}

export function readPlannedCarrierSelection(tenantId) {
  let saved;
  try {
    saved = window.localStorage.getItem(plannedCarrierStorageKey(tenantId));
  } catch (_) {
    return { ids: [], storageAvailable: false };
  }
  try {
    return { ids: normalizePlannedCarrierSelection(JSON.parse(saved || "[]")), storageAvailable: true };
  } catch (_) {
    // A damaged preference does not mean browser storage is unavailable.
    return { ids: [], storageAvailable: true };
  }
}
